
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 36 36","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"fill":"orange","width":"36","height":"36","rx":"1.5"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"8.791","cy":"27.209","r":"4.605"}}),_c('path',{attrs:{"d":"M4.186 17.79C11.816 17.79 18 23.695 18 30.978h4.605c0-9.71-8.247-17.582-18.419-17.582v4.396z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M4.186 8.651a22.326 22.326 0 0 1 22.326 22.326h4.465c0-14.796-11.995-26.791-26.791-26.791v4.465z","fill":"#FFF"}})])
      }
    
      }
    